export default __webpack_public_path__ + "static/media/BirlaEstatesLogo.de198da8.webp";